// localStorage key for the guided tour's last reached step, so a reload or
// next login resumes the tour instead of restarting it from step 0.
export const WALKTHROUGH_STEP_KEY = "mm-walkthrough-step";
